import { useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";
import * as S from "./styles";

import Passengers from "../../../../assets/icons/passengers.svg";
import CarDoors from "../../../../assets/icons/carDoors.svg";
import CarGear from "../../../../assets/icons/carGear.svg";
import CarAc from "../../../../assets/icons/carAC.svg";
import CarPlaceholder from "../../../../assets/icons/Car.svg";
import { format, intervalToDuration, parseISO } from "date-fns";
import { ThemeButton } from "../../../ThemeButton/styles";
import { useGlobal } from "../../../../contexts/globalContext";
import CurrencyFormat from "react-currency-format";
import { addFeeByDestinoFerias } from "../../../../utils/addFeeByDestinoFerias";
import RegisterModal from "../../../RegisterModal";
import { Tooltip } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

const CarCard = ({ car, searchState, buscaAtual }) => {
	let history = useHistory();
	const [rentalDays, setRentalDays] = useState(0);
	const { user, signed } = useGlobal();
	const [isOpenRegisterModal, setIsOpenRegisterModal] = useState(false);
	const [shortenCoinAlias, setShortenCoinAlias] = useState("Pts");
	const [imgError, setImgError] = useState(false);

	const handleRegisterModal = () => setIsOpenRegisterModal((prev) => !prev);

	const getValuesByUser = (val) => {
		let value = signed ? val * user?.catalog?.catalogCurrencyConfig?.conversionRate : val;
		if (user?.campaign) value = addFeeByDestinoFerias(value, buscaAtual);
		return signed ? Math.ceil(Math.round(value)) : value;
	};

	const getPointsPrice = () => {
		if (car?.pointsPrice != null) return car.pointsPrice;
		return getValuesByUser(car?.totalAmount);
	};

	const getCompanyImage = (car) => {
		if (car?.urlLogoCompany) return car.urlLogoCompany;
		if (car.companyName?.toUpperCase() === "LOCALIZA") return "/img/localiza.svg";
		return "https://via.placeholder.com/150";
	};

	useEffect(() => {
		setRentalDays(
			intervalToDuration({
				start: new Date(car?.dropoffDateTime),
				end: new Date(car?.pickupDateTime),
			}).days
		);
	}, [car?.dropoffDateTime, car?.pickupDateTime]);

	const handleSubmit = () => {
		sessionStorage.setItem("@CarSelected", JSON.stringify({ ...car, searchState }));
		if (user?.guest || user?.travelVoucher) return handleRegisterModal();
		history.push("/busca/resumo");
	};

	useEffect(() => {
		setShortenCoinAlias(user?.campaign?.campaignConfig?.shortenCoinAlias || "Pts");
	}, [user?.campaign?.campaignConfig?.shortenCoinAlias]);

	const showPoints = signed && !user?.guest && !user?.campaign?.disablePointActivity;
	const pickupTime = format(parseISO(car?.pickupDateTime), "HH:mm");
	const dropoffTime = format(parseISO(car?.dropoffDateTime), "HH:mm");
	const dropoffAddress = searchState?.mesmoLocal ? car?.pickupAddress : car?.dropoffAddress;

	return (
		<S.Wrapper>
			<RegisterModal open={isOpenRegisterModal} onClose={handleRegisterModal} travelVoucherUser={user?.travelVoucher} />

			{/* Car image */}
			<S.ImageArea>
				<img
					src={imgError || !car?.urlCarImg ? CarPlaceholder : car.urlCarImg}
					alt={car?.model || "Carro"}
					className={imgError || !car?.urlCarImg ? "placeholder" : "car-img"}
					onError={() => setImgError(true)}
				/>
			</S.ImageArea>

			{/* Main info */}
			<S.InfoSection>
				<div className="car-header">
					<span className="car-name">{car?.model || car?.categoryName}</span>
				</div>

				{car?.categoryName && (
					<span className="category-badge">{car?.categoryName}</span>
				)}

				<div className="specs-row">
					{car?.capacity && (
						<S.SpecChip>
							<img src={Passengers} alt="" />
							{car.capacity} pass.
						</S.SpecChip>
					)}
					{car?.numberDoors && (
						<S.SpecChip>
							<img src={CarDoors} alt="" />
							{car.numberDoors} portas
						</S.SpecChip>
					)}
					<S.SpecChip>
						<img src={CarGear} alt="" />
						{car?.automaticTransmission ? "Automático" : "Manual"}
					</S.SpecChip>
					{car?.airConditioning && (
						<S.SpecChip>
							<img src={CarAc} alt="" />
							AC
						</S.SpecChip>
					)}
				</div>

				<div className="locations">
					<S.LocationRow variant="pickup">
						<div className="dot" />
						<div className="location-info">
							<span className="location-label">Retirada</span>
							<span className="location-time">{pickupTime}</span>
							<span className="location-address">{car?.pickupAddress}</span>
						</div>
					</S.LocationRow>
					<S.LocationRow variant="dropoff">
						<div className="dot" />
						<div className="location-info">
							<span className="location-label">Devolução</span>
							<span className="location-time">{dropoffTime}</span>
							<span className="location-address">{dropoffAddress}</span>
						</div>
					</S.LocationRow>
				</div>

				{car?.fareOptions?.[0]?.fares?.length > 0 && (() => {
					const fares = car.fareOptions[0].fares;
					const tooltipContent = fares
						.map((f) => f.description)
						.filter(Boolean)
						.join("<br/>");
					if (!tooltipContent) return null;
					return (
						<S.FareRow>
							<span className="fare-name">Detalhes da tarifa</span>
							<Tooltip
								title={<span style={{ fontSize: 12 }} dangerouslySetInnerHTML={{ __html: tooltipContent }} />}
								placement="top"
								arrow
							>
								<InfoOutlinedIcon className="fare-info-icon" />
							</Tooltip>
						</S.FareRow>
					);
				})()}

				{car?.paidOnDestination?.price?.amount > 0 && (
					<S.PaidOnDestinationNotice>
						<span className="notice-label">
							{car.paidOnDestination.description || "Valor a ser pago no local de retirada/devolução"}
							<strong>
								<CurrencyFormat
									fixedDecimalScale
									value={car.paidOnDestination.price.amount}
									displayType="text"
									decimalSeparator=","
									decimalScale={2}
									prefix={`${car.paidOnDestination.price.currency || "BRL"} `}
								/>
							</strong>
						</span>
					</S.PaidOnDestinationNotice>
				)}
			</S.InfoSection>

			{/* Price panel */}
			<S.PricePanel>
				<img
					className="company-logo-price"
					src={getCompanyImage(car)}
					alt={car.companyName?.toUpperCase() || "Locadora"}
					onError={(e) => { e.target.style.display = "none"; }}
				/>

				<div className="price-amount">
					{showPoints ? (
						<>
							<span className="currency-prefix">{shortenCoinAlias}</span>
							<span className="value">{getPointsPrice()}</span>
						</>
					) : (
						<span className="value">
							<CurrencyFormat
								fixedDecimalScale
								value={car?.cashPrice ?? car?.totalAmount}
								displayType="text"
								decimalSeparator=","
								decimalScale={2}
								prefix="R$ "
							/>
						</span>
					)}
				</div>

				<span className="price-label">
					por {rentalDays} {rentalDays === 1 ? "dia" : "dias"}
				</span>

				<ThemeButton onClick={handleSubmit} className="button-select">
					Selecionar
				</ThemeButton>
			</S.PricePanel>
		</S.Wrapper>
	);
};

export default CarCard;
